import apiUrl from '../config/apiUrl';
import fetchUrl from '../utils/fetchUrl';

export const LIVE_PRICE = async () => {
  return await fetchUrl({
    url: `${apiUrl}live-data/price`,
    method: 'POST',
    body: {
      dstCurrency: '',
      srcCurrency: '',
    },
  });
};
